import { c as _c } from "react/compiler-runtime";
import { RichText } from '@7f-ui/components/rich-text/rich-text';
import type { AccommodationRoomSegment } from '@data-access/graphql/schema.types';
import { AccommodationRoomSegments } from '@feat/feat-accommodation/details';
import Image from 'next/image';
import { sanitizeBackendHtml } from '@/lib/security/sanitize-html';
type AppSingleRoomDetailsProps = {
  room: {
    title: string;
    bathrooms: number;
    size?: number | null;
    descriptionHtml: string;
    images: {
      url: string;
    }[];
    segments: AccommodationRoomSegment[];
  };
};
export function AppSingleRoomDetails(t0) {
  const $ = _c(19);
  const {
    room
  } = t0;
  let t1;
  if ($[0] !== room.bathrooms || $[1] !== room.segments || $[2] !== room.size) {
    t1 = <AccommodationRoomSegments segments={room.segments} bathrooms={room.bathrooms} size={room.size} />;
    $[0] = room.bathrooms;
    $[1] = room.segments;
    $[2] = room.size;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== room.descriptionHtml) {
    t2 = sanitizeBackendHtml(room.descriptionHtml);
    $[4] = room.descriptionHtml;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <RichText text={t2} />;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== room.images || $[9] !== room.title) {
    let t5;
    if ($[11] !== room.title) {
      t5 = image => <div key={image.url} className="relative aspect-4/3 w-full overflow-hidden rounded-xl last:col-span-2 sm:last:col-span-1 sm:first:col-span-2 md:aspect-16/9"><Image className="object-cover" src={image.url} alt={room.title ?? ""} fill={true} sizes="(max-width: 1024px) 640px, 1080px" /></div>;
      $[11] = room.title;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = room.images.slice(0, 3).map(t5);
    $[8] = room.images;
    $[9] = room.title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <div className="grid grid-cols-2 gap-4">{t4}</div>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t5) {
    t6 = <div className="grid gap-6">{t1}{t3}{t5}</div>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}